/*
 * AppKeyPair.js
 *
 * Event handlers for working with App Key Pairs.
 */

export function addAppKeyPairHandlers() {
  // Delete an app key pair
  $('.AppKeyPair-delete').on('click.delete-app-key-pair', function (event) {
    event.preventDefault()
    $.meDialog.yesno('Confirm', 'Delete this app key pair?', () => {
      $.post(
        `/account/admin_homepage.delete_app_key_pair/-/${$(this).data('id')}`
      )
        .done(() => {
          window.location = '/account/admin_homepage.organizations/-/'
        })
        .fail(() => {
          $.meDialog.topMessage('An error occurred', 4000, 'danger')
        })
    })
  })
}
